import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    private pageWrapper = null;

    private sidebarOpen = false;
    private mobileSidebarPresent = false;

    constructor() { }

    public unsubscribe(subscription: Subscription) {
        if (subscription) { subscription.unsubscribe(); }
    }

    public setPageWrapper(pageWrapper) {
        this.pageWrapper = pageWrapper;
    }

    public scrollTop() {
        if (this.hasPageWrapper()) {
            try {
                this.pageWrapper.scroll(0, 0);
            } catch {
                console.log('Cant scroll top on IE');
            }
        }
    }

    public hasPageWrapper() {
        return !!this.pageWrapper;
    }

    public getSidebarState() {
        return this.sidebarOpen;
    }

    public setSidebarState(sidebarOpen) {
        return this.sidebarOpen = sidebarOpen;
    }

    public getMobileSidebarState() {
        return this.mobileSidebarPresent;
    }

    public setMobileSidebarState(mobileSidebarPresent) {
        return this.mobileSidebarPresent = mobileSidebarPresent;
    }

}
